// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"PlayIconLayer_iconWrapper_1fr9biR","zoomIcon":"PlayIconLayer_zoomIcon_rL8RbLO"};